import React from 'react';
import PropTypes from 'prop-types';

function Translate({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        d="M12.474 21l1.1-2.69M21 21l-1.1-2.69m0 0l-3.075-7.975a.095.095 0 00-.177 0l-3.074 7.976m6.326 0h-6.326M3 4.421h6.158m6.158 0h-2.369m-3.79 0V3m0 1.421h3.79m0 0c-.326 1.63-1.504 4.785-3.936 7.706m-4.116 3.662a18.113 18.113 0 004.116-3.662m0 0c-.74-.674-2.411-2.59-3.169-4.864m3.169 4.864c.523.59 1.852 1.957 2.989 2.715"
      />
    </svg>
  );
}

Translate.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Translate;
